{
  "achievement-center": "اچیومنٹ سینٹر",
  "admin": "ایڈمن",
  "admin-learn": "ایڈمن سیکھیں اور کمائیں",
  "admin-p2p": "ایڈمن P2P",
  "admin-referrals": "ایڈمن ریفرلز",
  "admin-rewards": "ایڈمن ری وارڈز",
  "ai-arbitrage-scanner": "اے آئی آربیٹریج اسکینر",
  "ai-assistant": "اے آئی ٹریڈنگ اسسٹنٹ",
  "ai-copy-trading": "اے آئی کاپی ٹریڈنگ",
  "ai-grid-trading": "اے آئی گرڈ ٹریڈنگ",
  "ai-launchpad": "اے آئی لانچ پیڈ",
  "ai-market-scanner": "اے آئی مارکیٹ اسکینر",
  "ai-news": "اے آئی نیوز",
  "ai-portfolio": "اے آئی پورٹ فولیو مینیجر",
  "ai-profit-calculator": "اے آئی پروفٹ کیلکولیٹر",
  "ai-risk-manager": "اے آئی رسک مینیجر",
  "ai-smart-alerts": "اے آئی اسمارٹ الرٹس",
  "ai-trust-score": "اے آئی ٹرسٹ اسکور",
  "ai-whale-alerts": "اے آئی وہیل الرٹس",
  "ai-whale-heatmap": "اے آئی وہیل ہیٹ میپ",
  "ai-whale-tracker": "اے آئی وہیل ٹریکر",
  "buy": "خریدیں",
  "certificates": "میرے سرٹیفکیٹس",
  "dashboard": "ڈیش بورڈ",
  "exalt-utility-center": "ایگزالٹ یوٹیلٹی سینٹر",
  "futures": "فیوچرز",
  "kyc": "کے وائی سی درخواستیں",
  "kyc-submit": "KYC جمع کریں",
  "learnearn": "لرن اینڈ ارن",
  "listings": "لسٹنگز",
  "markets": "مارکیٹس",
  "notification-center": "نوٹیفکیشن سینٹر",
  "orders": "آرڈرز",
  "p2p": "پی ٹو پی",
  "profile": "پروفائل",
  "referral": "ریفرل",
  "reputation-center": "کمیونٹی ریپوٹیشن",
  "rewards": "ریوارڈز",
  "settings": "سیٹنگز",
  "social-trading": "سوشل ٹریڈنگ",
  "spotTrading": "اسپاٹ ٹریڈنگ",
  "staking": "اسٹیکنگ",
  "support": "سپورٹ",
  "trade": "ٹریڈ",
  "transactions": "ٹرانزیکشن ہسٹری",
  "wallets": "والٹس",
  "web3wallet": "ویب 3 والیٹ"
}